import { FC } from 'react';

export const HashPage: FC = () => {
  return <div>hash: {import.meta.env.VITE_VERSION}</div>;
};
